import { SelectButton } from "./SelectButton";

export const PitchResultGrid = ({ options, selected, onChange, disabled }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 gap-1 sm:gap-1.5">
    {options.map((option) => (
      <SelectButton
        key={option.value}
        selected={selected === option.value}
        onClick={() => onChange(option.value)}
        disabled={disabled}
      >
        {option.label}
      </SelectButton>
    ))}
  </div>
);
